import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Music from "@/pages/Music";
import Formations from "@/pages/Formations";
import Modeling from "@/pages/Modeling";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FeelsRight from "@/pages/FeelsRight";

function App() {
  return (
    <HelmetProvider>
      <div className="App grain vignette" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/music" element={<Music />} />
              <Route path="/formations" element={<Formations />} />
              <Route path="/modeling" element={<Modeling />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            {/* Hidden single landing — not in nav */}
            <Route path="/feels-right" element={<FeelsRight />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
